export const env = {
  version: import.meta.env.VITE_APP_VERSION,
  api_url: import.meta.env.VITE_APP_API_URL as string,
  engine_url: import.meta.env.VITE_APP_MOTEUR_API_URL as string,
  port: import.meta.env.VITE_PORT as string,
};